// @flow

import {
  DraftLiveStateEnum,
  ABSENCE_REASON_TYPES,
  ABSENCE_REASON_STATE,
} from "@modules/service/constants";
import type { AbsenceReasonsState } from "./types";

export const initialState: AbsenceReasonsState = {
  requestsInProgress: 0,
  list: null,
  schema: null,
  current: null,
  assignments: [],
  modals: {
    showAddAbsenceReasonModal: false,
    modalStep: 1,
    showEditModal: false,
  },
  filterState: ABSENCE_REASON_STATE.ALL,
  filterType: ABSENCE_REASON_TYPES.ALL,
  isLoading: false,
};

export default initialState;
